import React, { useState } from 'react';
import AppSidebar from './AppSidebar';
import AppHeader from './AppHeader';
import './AppLayout.css';

function AppLayout({ children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="app-layout">
      <AppSidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      <div className="app-layout-main">
        <AppHeader onMenuClick={toggleSidebar} />
        <main className="app-content">
          {children}
        </main>
      </div>
    </div>
  );
}

export default AppLayout;
